const messages: Record<string, string> = {
	'landing.paragraph':
		'Please take 8 photos of the vehicle and a photo of the registration certificate.',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'The front-right of the vehicle',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'The rear-right of the vehicle',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'The rear-left of the vehicle',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'The front-left of the vehicle',

	'invalidFile.size.title': 'Incorrect image size',
	'invalidFile.size.description': 'The image size is bigger than the maximum required',
	'invalidFile.extension.title': 'File type is not supported',
	'invalidFile.extension.description':
		'The specified file type is not supported. Supported file types: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp',
};

export default messages;
